window.UtilityHelper = class {

	static throttle (limit, callback, immediate = true) {
		let waiting = false;                     // Inicialmente, no estamos esperando
		return function () {
			const context = this;                // Capturamos el contexto correcto de 'this'
			const args = arguments;              // Capturamos los argumentos
			if (!waiting) {                      // Si no estamos esperando
				if (immediate) {                 // Si se permite la ejecución inmediata
					callback.apply(context, args); // Ejecutamos la función del usuario
				}
				waiting = true;                  // Bloqueamos futuras invocaciones
				setTimeout(function () {         // Después de un periodo de tiempo
					waiting = false;             // Permitimos nuevas invocaciones
					if (!immediate) {            // Si la opción no es ejecutar inmediatamente
						callback.apply(context, args); // Ejecutamos ahora la función
					}
				}, limit);
			}
		}
	}

	static debounce(delay, callback) {
		let timeoutId;                                  // Mantiene referencia al temporizador
		return function () {
			const context = this;                       // Captura el contexto correcto de 'this'
			const args = arguments;                     // Guarda los argumentos
			clearTimeout(timeoutId);                    // Limpia cualquier temporizador previo
			timeoutId = setTimeout(function () {        // Reinicia el temporizador
				callback.apply(context, args);          // Ejecuta la función después del retardo
			}, delay);
		}
	}

	static sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	static cssVar(name, value){
		if(name[0]!='-') name = '--'+name //allow passing with or without --
		if(value) document.documentElement.style.setProperty(name, value)
		return getComputedStyle(document.documentElement).getPropertyValue(name);
	}

	static copyToClipboard(text) {
        const tmp = document.createElement('textarea');
        tmp.value = text;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
    }

	static split(src) {
		if( typeof(src) == 'string' && src.length > 0 )
			return src.split(',');
		return [];
    }

	static includes(src, id) {
		return this.split(src).includes( String(id) );
	}

	static getObjectByValue (array, key, value) {
        return array.filter(function (object) {
            return object[key] === value;
        });
    }

	static getObjectByKey(obj, key) {
        let newObj = {};
        for(let i = 0, len = Object.keys(obj).length; i < len; i++) {
            newObj[ obj[i][key] ] = obj[i];
        }
        return newObj;
    }

	static getArrayByKey(obj, key) {
        let newObj = {};
        for(let i = 0, len = Object.keys(obj).length; i < len; i++) {
            if( !Array.isArray(newObj[ obj[i][key] ]) ) {
                newObj[ obj[i][key] ] = [];
            }
            newObj[ obj[i][key] ].push(obj[i]);
        }
        return newObj;
    }

	static isMobile(browser = 'any') {

        
		const Android = function Android() {
			return navigator.userAgent.match(/Android/i);
		};
		const BlackBerry = function BlackBerry() {
			return navigator.userAgent.match(/BlackBerry/i);
		};
		const iOS = function iOS() {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		};
		const Opera = function Opera() {
			return navigator.userAgent.match(/Opera Mini/i);
		};
		const Windows = function Windows() {
			return navigator.userAgent.match(/IEMobile/i);
		};
        
        switch(browser) {
            case 'Android': return Android();
            case 'BlackBerry': return BlackBerry();
            case 'iOS': return iOS();
            case 'Opera': return Opera();
            case 'Windows': return Windows();
            case 'any': return (Android() || BlackBerry() || iOS() || Opera() || Windows());
        }
    }

	static openLink(url, target = "_blank") {
		const link = document.createElement("a");
		link.target = target;
		link.rel = "noreferrer noopener";
		link.href = url;
		link.click();
	}


	static getDevice(device) {
        if(window.innerWidth <= 640) return 'smartphone';
        if(navigator.userAgent.match(/Tablet|iPad|Android/i) && window.innerWidth <= 1280) return 'tablet';
        return 'desktop';
    }

	static getAndroidVer() {
        var match = navigator.userAgent.toLowerCase().match(/android\s([0-9\.]*)/i); 
        return match ? match[1] : undefined; 
    }

	/**
	 * convert RFC 1342-like base64 strings to array buffer
	 * @param {mixed} obj
	 * @returns {undefined}
	 */
	static recursiveBase64StrToArrayBuffer(obj) {
		let prefix = '=?BINARY?B?';
		let suffix = '?=';
		if (typeof obj === 'object') {
			for (let key in obj) {
				if (typeof obj[key] === 'string') {
					let str = obj[key];
					if (str.substring(0, prefix.length) === prefix && str.substring(str.length - suffix.length) === suffix) {
						str = str.substring(prefix.length, str.length - suffix.length);

						let binary_string = window.atob(str);
						let len = binary_string.length;
						let bytes = new Uint8Array(len);
						for (let i = 0; i < len; i++)        {
							bytes[i] = binary_string.charCodeAt(i);
						}
						obj[key] = bytes.buffer;
					}
				} else {
					this.recursiveBase64StrToArrayBuffer(obj[key]);
				}
			}
		}
	}

	/**
	 * Convert a ArrayBuffer to Base64
	 * @param {ArrayBuffer} buffer
	 * @returns {String}
	 */
	static arrayBufferToBase64(buffer) {
		let binary = '';
		let bytes = new Uint8Array(buffer);
		let len = bytes.byteLength;
		for (let i = 0; i < len; i++) {
			binary += String.fromCharCode( bytes[ i ] );
		}
		return window.btoa(binary);
	}

};
